const STRIPE_PK =
  process.env.STRIPE_PK ||
  'pk_test_51LfS67Jc8cbXO9ro6k4aGYR8PycfW8Cvxe4rbtv04RvKkCcCIIrDw73pwtfmugLf0QfNCWTmM1O8xSrraweDMK1m008vCIp89P';
export default STRIPE_PK;
